export * from './storage-product-config-template';
